import React, { Component, useState, useCallback, useEffect } from 'react';
import { authProvider } from '../../authProvider';
import { CommandBar } from '@fluentui/react/lib/CommandBar';
import { DetailsList, DetailsListLayoutMode, Selection, SelectionMode, IColumn } from '@fluentui/react/lib/DetailsList';
import { TextField } from '@fluentui/react/lib/TextField';
import axios from 'axios';

function RevenueRangeEditor() {
    var rootUrl = window.location.protocol + '//' + window.location.host + '/';
    const [headers, setHeaders] = useState(null);
    const [ranges, setRanges] = useState([]);
    const [editedRange, setEditedRange] = useState(null);
    const [hasChanges, setHasChanges] = useState(false);

    // just an example object
    const referenceRange = {
        id: 0,
        rangeText: "",
        lowerValue: 0,
        upperValue: 0
    };

    const authenticate = useCallback(async () => {
        var result = await authProvider.getAccessToken();
        var tkn = result.accessToken
        if (tkn) {
            var hdrs = { 'Authorization': "Bearer " + tkn };

            // Load Industries
            setHeaders(hdrs);
        }
    }, [setHeaders])
    const loadRanges = useCallback(async () => {
        if (headers) {
            // Load Industries if headers have been set.
            var res = await axios.get(rootUrl + "RevenueRange", { headers: headers })
            if (res.data) {
                setRanges(res.data);
            }
        }
    }, [setRanges, headers]);
    const editRange = useCallback((range) => {
        setEditedRange(range);
    }, [setEditedRange]);
    const addRange = useCallback(() => {
        setRanges([...ranges, { id: 0, rangeText: "", lowerValue: 0, upperValue: 0 }]);
    }, [setRanges, ranges]);
    const updateRange = useCallback((range) => {
        range.hasChanges = true;
        setHasChanges(true);
        setRanges(ranges.map((itm) => {
            return itm.id == range.id ? range : itm;
        }))
    }, [setRanges, setHasChanges, ranges])
    const saveRanges = useCallback(async() => {
        // Save ranges;
    }, [headers])
    useEffect(() => {
        (async () => {
            await authenticate();
        })();
    }, [authenticate]);
    useEffect(() => {
        (async () => {
            await loadRanges();
        })();
    }, [loadRanges, headers]);

    const onRangeTextChange = useCallback((event, newValue) => {
        editedRange.rangeText = newValue;
        updateRange(editedRange);
    }, [editedRange, updateRange]);
    const onLowerValueChange = useCallback((event, newValue) => {
        editedRange.lowerValue = newValue;
        updateRange(editedRange);
    }, [editedRange, updateRange]);
    const onUpperValueChange = useCallback((event, newValue) => {
        editedRange.upperValue = newValue;
        updateRange(editedRange);
    }, [editedRange, updateRange]);

    const columns = [
        { key: "column1", name: "Id", fieldName: "id", isResizable: true, minWidth: 60, maxWidth: 200 },
        {
            key: "column2",
            name: "Range Text",
            fieldName: "rangeText",
            isResizable: true,
            onRender: (itm) => {
                if (itm === editedRange) {
                    return <TextField value={editedRange.rangeText} onChange={onRangeTextChange} />;
                }
                else {
                    return <span>{itm.rangeText}</span>
                }
            }
        },
        {
            key: "column3",
            name: "Lower Value",
            fieldName: "lowerValue",
            isResizable: true,
            onRender: (itm) => {
                if (itm === editedRange) {
                    return <TextField value={editedRange.lowerValue} onChange={onLowerValueChange} />;
                }
                else {
                    return <span>{itm.lowerValue}</span>
                }
            }
        },
        {
            key: "column4",
            name: "Upper Value",
            fieldName: "upperValue",
            isResizable: true,
            onRender: (itm) => {
                if (itm === editedRange) {
                    return <TextField value={editedRange.upperValue} onChange={onUpperValueChange} />;
                }
                else {
                    return <span>{itm.upperValue}</span>
                }
            }
        }
    ];
    const cbItems = [
        {
            key: 'newItem',
            text: 'Add Range',
            iconProps: { iconName: 'Add' },
            onClick: addRange
        },
        {
            key: 'saveItem',
            text: "Save",
            disabled: !hasChanges,
            iconProps: { iconName: 'Save' },
            onClick: saveRanges
        }
    ];

    const updateSelection = useCallback(() => {
        var rangeToEdit = null;
        if (_selection.count !== 0) {
            rangeToEdit = _selection.getSelection()[0];
        }
        editRange(rangeToEdit);
    }, [editRange]);
    const _selection = new Selection({
        onSelectionChanged: updateSelection
    });


    const onItemInvoked = useCallback((item) => {
        editRange(item);
    }, [editRange]);
    return (
        <div className="container">
            <h1>Manage Revenue Ranges</h1>
            <CommandBar items={cbItems} />
            <DetailsList items={ranges} columns={columns} selection={_selection} />
        </div>
    );
}

export default RevenueRangeEditor;